(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qomoor-apparel-details"] && !Shopify.designMode) return;
  try {
    

(function () {
  function prepareWideTables() {
    document.querySelectorAll('.qomoor-apparel-details__content table, .qomoor-pdp-story__product-information-content table').forEach(function (table) {
      if (table.dataset.qmWideTable) return;
      var rows = Array.from(table.rows);
      if (rows.length < 2) return;
      var header = table.tHead && table.tHead.rows[0] || rows[0];
      var heads = Array.from(header.cells);
      if (heads.length <= 1) return;
      if (!rows.every(function (row) { return row.cells.length === heads.length && Array.from(row.cells).every(function (cell) { return cell.colSpan === 1 && cell.rowSpan === 1; }); })) return;
      function text(cell) {
        var copy = cell.cloneNode(true);
        copy.querySelectorAll('br').forEach(function (br) { br.replaceWith(' '); });
        return copy.textContent.replace(/\s+/g, ' ').trim();
      }
      var labels = heads.map(text);
      if (!table.tHead && !heads.some(function (cell) { return cell.tagName === 'TH'; }) && !/size|measurement|length|bust|chest|height|waist|hip|age/i.test(labels.join(' '))) return;
      header.classList.add('qm-wide-table-header');
      rows.filter(function (row) { return row !== header; }).forEach(function (row) {
        Array.from(row.cells).forEach(function (cell, index) {
          var value = document.createElement('span');
          value.className = 'qm-wide-table-value';
          while (cell.firstChild) value.appendChild(cell.firstChild);
          if (labels[index]) {
            var label = document.createElement('span');
            label.className = 'qm-wide-table-label';
            label.textContent = labels[index];
            cell.appendChild(label);
          } else {
            cell.classList.add('qm-wide-table-unlabelled');
          }
          cell.appendChild(value);
        });
      });
      table.dataset.qmWideTable = 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareWideTables, {once:true});
  else prepareWideTables();
  document.addEventListener('shopify:section:load', prepareWideTables);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qomoor-costume-hub-products"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

  const qomoorMobileFilterMedia = window.matchMedia('(max-width: 749px)');

  document.addEventListener('click', (event) => {
    if (!qomoorMobileFilterMedia.matches) return;

    const trigger = event.target.closest('.qomoor-costume-products .facets-toggle__button');
    if (!trigger) return;

    requestAnimationFrame(() => {
      document
        .querySelectorAll('.qomoor-costume-products #filters-drawer .facets__panel[open]')
        .forEach((panel) => panel.removeAttribute('open'));
    });
  });

  const qomoorCostumeHolidayValues = new Set([
    'halloween',
    'christmas',
    'easter',
    "st. patrick's day",
    "valentine's day"
  ]);

  const qomoorNormalizeFilterValue = (value) => value
    .replace(/[’‘]/g, "'")
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  const qomoorRefineCostumeFacets = (root = document) => {
    root.querySelectorAll('.qomoor-costume-products .facets__panel').forEach((panel) => {
      const summary = panel.querySelector(':scope > .facets__summary') || panel.querySelector('.facets__summary');
      const summaryText = qomoorNormalizeFilterValue(summary?.textContent || '');
      const inputNames = Array.from(panel.querySelectorAll('input[name]'), (input) => input.name);
      const configuredHiddenFacets = new Set(
        (panel.closest('.qomoor-costume-products')?.dataset.hiddenFilterLabels || '')
          .split('|')
          .map(qomoorNormalizeFilterValue)
          .filter(Boolean)
      );
      const isConfiguredHiddenFacet = Array.from(configuredHiddenFacets)
        .some((label) => summaryText.startsWith(label));

      const isThemeFacet = inputNames.some((name) => name.includes('custom.party_theme'))
        || summaryText.startsWith('shop by theme');
      const isCostumeWorldFacet = inputNames.some((name) => name.includes('custom.costume_world'))
        || summaryText.startsWith('costume world');
      const isCostumeCategoryFacet = inputNames.some((name) => name.includes('custom.costume_category'))
        || summaryText.startsWith('costume category');
      const isAvailabilityFacet = inputNames.some((name) => name === 'filter.v.availability')
        || summaryText.startsWith('availability');
      const isColorFacet = inputNames.some((name) => name.includes('color') || name.includes('colour'))
        || summaryText.startsWith('color')
        || summaryText.startsWith('colour');
      const isPriceFacet = inputNames.some((name) => name.startsWith('filter.v.price'))
        || summaryText.startsWith('price');

      if (
        isThemeFacet
        || isCostumeWorldFacet
        || isCostumeCategoryFacet
        || isAvailabilityFacet
        || isColorFacet
        || isPriceFacet
        || isConfiguredHiddenFacet
      ) {
        panel.hidden = true;
        panel.setAttribute('aria-hidden', 'true');
        return;
      }

      if (panel.dataset.qomoorInitialCollapsed !== 'true') {
        panel.removeAttribute('open');
        panel.dataset.qomoorInitialCollapsed = 'true';
      }

      const isOccasionFacet = inputNames.some((name) => name === 'filter.p.m.custom.occasion')
        || summaryText.startsWith('occasion');

      if (!isOccasionFacet) return;

      const summaryLabel = summary?.querySelector('.facets__label');
      if (summaryLabel && summaryLabel.textContent.trim() !== 'Holiday') summaryLabel.textContent = 'Holiday';

      let visibleHolidayCount = 0;
      panel.querySelectorAll('input[name="filter.p.m.custom.occasion"]').forEach((input) => {
        const item = input.closest('.facets__inputs-list-item');
        if (!item) return;

        const sourceLabel = input.value || input.dataset.label || item.querySelector('label')?.textContent || '';
        const normalizedLabel = qomoorNormalizeFilterValue(sourceLabel.replace(/\s+\d+\s*$/, ''));
        const isHoliday = qomoorCostumeHolidayValues.has(normalizedLabel);

        item.hidden = !isHoliday;
        item.setAttribute('aria-hidden', isHoliday ? 'false' : 'true');
        if (isHoliday) visibleHolidayCount += 1;
      });

      panel.hidden = visibleHolidayCount === 0;
      panel.setAttribute('aria-hidden', visibleHolidayCount === 0 ? 'true' : 'false');
    });

    root.querySelectorAll('facet-remove-component').forEach((component) => {
      component.childNodes.forEach((node) => {
        if (node.nodeType !== Node.TEXT_NODE || !node.textContent.includes('Occasion:')) return;
        node.textContent = node.textContent.replace(/Occasion\s*:/, 'Holiday:');
      });
    });

    const qomoorReorderCostumeFacets = (wrapper) => {
      const panels = Array.from(wrapper.querySelectorAll('.facets__panel'))
        .filter((panel) => panel.closest('.facets__filters-wrapper') === wrapper);

      const findPanel = (parameter, label) => panels.find((panel) => {
        const hasParameter = Array.from(panel.querySelectorAll('input[name]'))
          .some((input) => input.name === parameter);
        const summary = panel.querySelector(':scope > .facets__summary') || panel.querySelector('.facets__summary');
        const summaryText = qomoorNormalizeFilterValue(summary?.textContent || '');
        return hasParameter || summaryText.startsWith(label);
      });

      const productTypePanel = findPanel('filter.p.product_type', 'product type');
      const audiencePanel = findPanel('filter.p.m.custom.audience', 'audience');
      if (!productTypePanel || !audiencePanel) return;

      const productTypeItem = productTypePanel.closest('.facets__item') || productTypePanel;
      const audienceItem = audiencePanel.closest('.facets__item') || audiencePanel;
      if (productTypeItem.parentElement !== audienceItem.parentElement) return;
      if (productTypeItem.nextElementSibling === audienceItem) return;

      productTypeItem.insertAdjacentElement('afterend', audienceItem);
    };

    root.querySelectorAll('.facets__filters-wrapper').forEach(qomoorReorderCostumeFacets);
  };

  const qomoorInitializeCostumeFacets = () => {
    document.querySelectorAll('.qomoor-costume-products').forEach((root) => {
      qomoorRefineCostumeFacets(root);
      if (root.dataset.qomoorHolidayObserver === 'true') return;

      root.dataset.qomoorHolidayObserver = 'true';
      const observer = new MutationObserver(() => qomoorRefineCostumeFacets(root));
      observer.observe(root, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', qomoorInitializeCostumeFacets, { once: true });
  } else {
    qomoorInitializeCostumeFacets();
  }

  document.addEventListener('shopify:section:load', qomoorInitializeCostumeFacets);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qomoor-party-products"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener('DOMContentLoaded', () => {
      const card = document.getElementById(url.hash.slice(1));
      if (card) card.scrollIntoView({ behavior: 'instant' });
    }, { once: true });
  }

  const qomoorMobileFilterMedia = window.matchMedia('(max-width: 749px)');

  document.addEventListener('click', (event) => {
    if (!qomoorMobileFilterMedia.matches) return;

    const trigger = event.target.closest('.qomoor-party-products .facets-toggle__button');
    if (!trigger) return;

    requestAnimationFrame(() => {
      document
        .querySelectorAll('.qomoor-party-products #filters-drawer .facets__panel[open]')
        .forEach((panel) => panel.removeAttribute('open'));
    });
  });

  } catch(e) { console.error(e); }
})();
})();
